import React, { useState, useEffect } from "react"
import { FormGroup, Modal } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import PropTypes from "prop-types"

import { API_STATUS } from "../../../../shared_components/widgets/utils"
import { logToServer } from "../../../../ErrorBoundary"
import PageLoadingPanel from "../../../../shared_components/widgets/PageLoadingPanel"
import PageErrorPanel from "../../../../shared_components/widgets/PageErrorPanel"
import { getObjectsList } from "../../../../Loaders"
import { CloseButton } from "../../../internationalization/LocaleFormatted"
import { stringifyDate } from "../../../../shared_components/utils"

export default function ModalViewDataUploadLogs({ show, onHide, sample = {} }) {
  const [status_init, setStatusInit] = useState(API_STATUS.LOADING)
  const [uploadfile, setUploadfile] = useState({})
  useEffect(() => {
    onInitialLoad()
  }, [])

  const onInitialLoad = () => {
    setStatusInit(API_STATUS.LOADING)
    setUploadfile({})

    getObjectsList(`/laboratory/sample-management/sample/${sample.id}/get_latest_sample_file/`)
      .then((file) => {
        setStatusInit(API_STATUS.SUCCESS)
        setUploadfile(file)
      })
      .catch((error) => {
        logToServer(error)
        console.error(error)
        setStatusInit(API_STATUS.ERROR)
      })
  }

  return (
    <Modal
      size={"lg"}
      dialogClassName={"common-modal"}
      show={show}
      onHide={onHide}
      style={{ overflowX: "scroll", overflowY: "scroll" }}
      backdrop={"static"}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa fa-arrow-circle-o-up" />
          &nbsp;&nbsp;
          <FormattedMessage
            id={"samplemanagement.upload.sample.data.logs"}
            description={"Sample Data Upload Logs"}
          />
          : &nbsp;
          <span>{sample.sample_id}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ width: "800px" }}>
          {status_init === API_STATUS.LOADING ? (
            <PageLoadingPanel />
          ) : status_init === API_STATUS.ERROR ? (
            <PageErrorPanel attemptReload={onInitialLoad} />
          ) : status_init === API_STATUS.SUCCESS ? (
            uploadfile ? (
              <>
                <table style={{ width: "100%", marginBottom: "20px" }}>
                  <tbody>
                    {[
                      ["general.id", "ID", "id"],
                      ["general.name", "Name", "name"],
                      ["general.description", "Description", "description"],
                      ["general.status", "Status", "transformation_state"],
                    ].map((entry, idx) => (
                      <tr key={`metadata${idx}`}>
                        <td>
                          <label>
                            <FormattedMessage id={entry[0]} defaultMessage={entry[1]} />:
                          </label>
                        </td>
                        <td>{uploadfile?.[entry[2]]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{ height: "350px", overflowY: "auto" }}>
                  <table className="table table-sm tbl_lanzatable">
                    <thead>
                      <tr>
                        <th style={{ width: "200px" }} className={"text-center"}>
                          <FormattedMessage id={"general.date"} description={"Date Column Header"} />
                        </th>
                        <th style={{ width: "100px" }} className={"text-center"}>
                          <FormattedMessage id={"general.status"} description={"Status Column Header"} />
                        </th>
                        <th style={{ minWidth: "350px" }} className={"text-center"}>
                          <FormattedMessage
                            id={"datatransfer.column.message"}
                            description={"Message Column Header"}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(uploadfile.transformation_logs || []).reverse().map((row, idx) => {
                        return (
                          <tr key={idx}>
                            <td className={"text-center"}>{stringifyDate(row.date)}</td>
                            <td className={"text-center"}>{row.state}</td>
                            <td>{row.message}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <div align="center" style={{ padding: "40px 0px" }}>
                <span className="fa fa-exclamation-circle" style={{ fontSize: "60px" }} />
                <h3>
                  <FormattedMessage
                    id={"samplemanagement.no.sample.data.files.uploaded.message"}
                    description={"No Sample Data Files Uploaded Message"}
                  />
                </h3>
              </div>
            )
          ) : (
            <></>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CloseButton onClose={onHide} />
      </Modal.Footer>
    </Modal>
  )
}

ModalViewDataUploadLogs.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  sample: PropTypes.object.isRequired,
}
